import React, { Component } from 'react'

import { IdentifiersCardWrapper, IdentifiersCardLabel } from './styles'
import identifierImg from '../../../static/adesivo-veloe.png'
import imgLoading from '../../../static/loading.gif'
import { gqlTotalIdentificadores } from '../../../alelo-logic/services/queries/vehicles'
import { gqlQuery } from '../../../alelo-logic/services/common/apolloClient'

export default class TotalIdentifiersCard extends Component {
  state = {
    totalTags: 'carregando...',
    loading: true
  }

  async componentDidMount() {
    const { data: { identificadoresPJV2: { paginacao } } } = await gqlQuery(
      gqlTotalIdentificadores,
      {
        idConta: this.props.account
      }
    )
    this.setState({ totalTags: paginacao.total || 0, loading: false })
  }

  render() {
    const { loading, totalTags } = this.state
    return (
      <IdentifiersCardWrapper>
        <IdentifiersCardLabel>
          <span>
            {loading ? (
              <img alt="carregando..." width="20px" height="20px" src={imgLoading} />
            ) : (
              totalTags
            )}
          </span>
          <p>Adesivos ativos</p>
        </IdentifiersCardLabel>
        <img src={identifierImg} alt="Adesivos" />
      </IdentifiersCardWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/DashboardIdentifiers/TotalIdentifiersCard.js